import Slider from "./Slider";
import CursorEffectSection from './CursorEffect';

export default function SliderWrap2() {

    return (
        <section className="slider_wrap">
              <CursorEffectSection/>
            <div data-wf--global-section-space--section-space="page-top" className="g_section_space w-variant-e359d2da-de19-6775-b122-3e06f925f39e"></div>
            <div className="slider_contain u-container-full">
                <div className="slider_layout u-grid-flex">
                    <div className="slider_content u-column-8 u-max-width-60ch">
                     
                    </div>
                </div>
                <Slider />

            </div>
           
        </section>
    )

}